<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" />
      <p class="mb-4">
        {{ $t('route.routePlaning.history.text') }} <strong>{{ routeRecord.route.name }}</strong>
      </p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <b-button @click="$router.go(-1)" variant="outline-primary">
            <i class="mc-fa icon-outline_arrow-left"></i> {{ $t('global.back') }}
          </b-button>
        </div>
      </div>
    </div>

    <McGrapqlTable
      :apiClient="query"
      :fields="fields"
      :hasCheckbox="false"
      :searchable="true"
      :withCard="true"
    >
      <template #cell(time)="data">
        <p>{{ momentDateShortMonth(data.value) }}</p>
        <span class="text-muted">{{ `${momentTime(data.value)}` }}</span>
      </template>

      <template #cell(title)="data">
        <p class="td__noellipsis">{{ data.value }}</p>
      </template>

      <template #cell(detail)="data">
        <p class="td__noellipsis">{{ data.value }}</p>
      </template>
    </McGrapqlTable>
  </Layout>
</template>
<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import { Helper } from '@/mixin/helper'
import { MixPanel } from '@/mixin/mixpanel'
import McGrapqlTable from '@/components/McGrapqlTable'
import { ROUTE_RECORD_AUDIT_LOGS, GET_ROUTE_RECORD } from '@/services/api/route'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Route',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McGrapqlTable,
  },
  mixins: [Helper, MixPanel],

  apollo: {
    routeRecord: {
      query: GET_ROUTE_RECORD,
      fetchPolicy: 'no-cache',
      manual: true,
      variables() {
        return {
          filter: {
            routeRecordId: Number(this.$route.params.routeRecordId),
          },
        }
      },
      skip() {
        return !this.$route.params.routeRecordId
      },
      result({ data, loading }) {
        if (!loading) {
          if (data.routeRecord.isSuccessful) {
            this.routeRecord = data.routeRecord.routeRecord
          } else {
            this.routeRecord = {}
            this.$mcToast.warning(data.routeRecord.message)
          }
        }
      },
    },
  },

  data() {
    return {
      routeRecord: {},
    }
  },

  computed: {
    title() {
      return this.$t('global.historyUpdate')
    },

    fields() {
      return [
        {
          key: 'time',
          label: this.$t('global.time.time'),
          sortable: false,
          thStyle: 'width: 350px',
        },
        {
          key: 'action',
          label: this.$t('global.changeDescription'),
          sortable: false,
          thStyle: 'width: 350px',
        },
        {
          key: 'detail',
          label: this.$t('global.information'),
          sortable: false,
          thStyle: 'width: 350px',
        },
        {
          key: 'user',
          label: this.$t('global.changed'),
          sortable: false,
          thStyle: 'width: 350px',
        },
      ]
    },

    query() {
      return {
        get: async (filter) => {
          const res = await this.$apollo.query({
            fetchPolicy: 'no-cache',
            query: ROUTE_RECORD_AUDIT_LOGS,
            variables: {
              filter: { ...filter, routeRecordId: parseInt(this.$route.params.routeRecordId) },
            },
          })

          return res.data.routeRecordAuditLogs.routeRecordAuditLogs
        },
      }
    },
  },

  mounted() {
    this.track('View Change History Route Planning')
  },
}
</script>
